"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsOnline = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useIsOnline = function useIsOnline() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return;
  }

  var _useState = (0, _react.useState)(window.navigator.onLine),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOnline = _useState2[0],
      setOnlineStatus = _useState2[1];

  (0, _react.useEffect)(function () {
    var toggleOnlineStatus = function toggleOnlineStatus() {
      return setOnlineStatus(window.navigator.onLine);
    };

    window.addEventListener("online", toggleOnlineStatus);
    window.addEventListener("offline", toggleOnlineStatus);
    return function () {
      window.removeEventListener("online", toggleOnlineStatus);
      window.removeEventListener("offline", toggleOnlineStatus);
    };
  }, [isOnline]);
  return isOnline;
};

exports.useIsOnline = useIsOnline;